<!--  Use our app Section -->
@if(!hideAppSection()){
<section class="container-fluid useourapp-section">
  <div class="container">
    <app-imagebox-one [showAppBtns]="true" [isImageLeft]="false" [imageStyle]="'max-height:518px;'"
      [heading]="('FOOTER.APPINFOTITLE' | translate)" [image]="sharedService.imagesUrl+'Footer-Mobile-bg.png'"
      [image]="sharedService.imagesUrl+'responcv-mobile-img.png'"></app-imagebox-one>
  </div>
</section>
}

<!--  Use our app Section End -->
@if(!hideFooterMainSection()){
<footer class="container-fluid">
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <div class="row">
          <div class="col-md-12 logo-col">
            <div class="footer-desc-logo" style="margin-bottom: 20px">
              <img src="{{sharedService.imagesUrl}}footer-logo.svg" />
            </div>
            <div class="footer-desc-section">

              <div class="footer-desc-section-text" [ngClass]="{
                'footer-desc-quotetation': sharedService.hideFooterRightSection
              }">
                {{ 'FOOTER.DESCRIPTION' | translate: { tenant: 'WOW' } }}
              </div>
              <div class="footer-desc-section-icons" *ngIf="!sharedService.hideFooterRightSection">
                <div class="footer-desc-section-icon">
                  <a [href]="Facebook" target="_blank" class="img-tage">
                    <img src="{{sharedService.imagesUrl}}icons/facebook.svg" />
                  </a>
                </div>
                <div class="footer-desc-section-icon">
                  <a [href]="Linkedin" target="_blank" class="img-tage">
                    <img src="{{sharedService.imagesUrl}}icons/linkedin.svg" />
                  </a>
                </div>
                <!-- <div class="footer-desc-section-icon">
                  <a [href]="Instragram" target="_blank" class="img-tage">
                    <img src="{{sharedService.imagesUrl}}icons/instargram.svg" />
                  </a>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <!-- Footer Menus -->
        @if(!sharedService.hideFooterRightSection){
        <div class="row footer-menu-section">
          <div class="col-md-4">
            <div class="footer-menus">
              <div class="footer-menu-item" (click)="formembership('membership')">
                <div class="footer-menu-item-title main-tile d-flex justify-content-between">{{
                  'MENU.MEMBERSHIP' | translate }}
                  <div class="menu-images">
                    <img *ngIf="activesection === 'membership'" src="{{sharedService.imagesUrl}}icons/arrow-up.svg" />
                    <img *ngIf="activesection !== 'membership'" src="{{sharedService.imagesUrl}}icons/arrow-down.svg" />
                  </div>
                </div>
                <div class="inner-links" (click)="closeimg($event)" *ngIf="innerlink" [class.hide-li]="innerlink"
                  [class.show-li]="activesection === 'membership'">
                  <a class="footer-menu-item-menu" [ngClass]="{'show-ul': activesection === 'membership'}"
                    [routerLink]="routes.plusMembership">
                    {{ 'MENU.EVERYDAY_CARE' | translate: { tenant: 'WOW' } }}
                  </a>

                  <a class="footer-menu-item-menu" [ngClass]="{'show-ul': activesection === 'membership'}"
                    [routerLink]="routes.healthSharing">
                    {{ 'MENU.HEALTH_SHARE_FOR_LARGE' | translate }}
                  </a>
                </div>
                <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div>

              </div>
              <div class="footer-menu-list">
                <div class="footer-menu-item">
                  <div class="footer-menu-item-title d-flex justify-content-between" (click)="onclick('employers')"> {{
                    'MENU.FOR_EMPLOYERS' | translate }}
                    <div class="menu-images">
                      <img *ngIf="activesection === 'employers'" src="{{sharedService.imagesUrl}}icons/arrow-up.svg" />
                      <img *ngIf="activesection !== 'employers'"
                        src="{{sharedService.imagesUrl}}icons/arrow-down.svg" />
                    </div>

                  </div>
                  <div class="footer-menu-item-line">
                    <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                      <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                    </svg>
                  </div>
                  <div class="inner-links" (click)="closeimg($event)" [class.hide-li]="innerlink"
                    [class.show-li]="activesection === 'employers'">
                    <a class="footer-menu-item-menu employers-benifites"
                      [ngClass]="{'show-ul': activesection === 'employers'}" [routerLink]="routes.employers">
                      {{ 'MENU.EMPLOYERS_BENEFITS' | translate }}
                    </a>
                  </div>
                </div>

                <div class="footer-menu-item">
                  <div class="footer-menu-item-title broker-title  d-flex justify-content-between"
                    (click)="onclick('broker')">
                    {{ 'MENU.FOR_BROKERS' | translate }}
                    <div class="menu-images">
                      <img *ngIf="activesection === 'broker'" src="{{sharedService.imagesUrl}}icons/arrow-up.svg" />
                      <img *ngIf="activesection !== 'broker'" src="{{sharedService.imagesUrl}}icons/arrow-down.svg" />
                    </div>
                  </div>
                  <div class="footer-menu-item-line">
                    <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                      <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                    </svg>
                  </div>
                  <div class="inner-links" (click)="closeimg($event)" [class.hide-li]="innerlink"
                    [class.show-li]="activesection === 'broker'">
                    <a class="footer-menu-item-menu employers-benifites"
                      [ngClass]="{'show-ul': activesection === 'broker'}" [routerLink]="routes.advocates">
                      {{ 'MENU.Brokers Benefits' | translate }}
                    </a>
                  </div>
                  <div class="footer-menu-item-line">
                    <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                      <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 for-members">
            <div class="footer-menus">
              <div class="footer-menu-item">
                <div class="footer-menu-item-title main-tile d-flex justify-content-between"
                  (click)="onclick('formember')">{{
                  'MENU.FOR_MEMBERS' | translate }}
                  <div class="menu-images">
                    <img *ngIf="activesection === 'formember'" src="{{sharedService.imagesUrl}}icons/arrow-up.svg" />
                    <img *ngIf="activesection !== 'formember'" src="{{sharedService.imagesUrl}}icons/arrow-down.svg" />
                  </div>
                </div>
                <div class="inner-links" (click)="closeimg($event)" [class.hide-li]="innerlink"
                  [class.show-li]="activesection === 'formember'">
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul': activesection === 'formember'
                }" [routerLink]="routes.officeVisit">{{ 'MENU.OFFICE_VISITS' | translate
                    }}</a>
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul': activesection === 'formember'
                }" [routerLink]="routes.virtualUrgentCare">
                    {{ 'MENU.VIRTUAL_URGENT_CARE' | translate }}
                  </a>
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul': activesection === 'formember'
                }" [routerLink]="routes.mentalHealth">{{ 'MENU.MENTAL_HEALTH' | translate
                    }}</a>
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul': activesection === 'formember'
                }" [routerLink]="routes.pharmacy">{{ 'MENU.PHARMACY' | translate }}</a>
                  <a class="footer-menu-item-menu" [routerLink]="routes.visionService">{{ 'MENU.VISION_CARE' | translate
                    }}</a>
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul': activesection === 'formember'
                }" [routerLink]="routes.dental">{{ 'MENU.DENTAL_CARE' | translate }}</a>
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul': activesection === 'formember'
                }" [routerLink]="routes.imaging">{{ 'MENU.IMAGING' | translate }}</a>
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul': activesection === 'formember'
                }" [routerLink]="routes.labTest">{{ 'MENU.LAB_TESTS' | translate }}</a>
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul': activesection === 'formember'
                }" [routerLink]="routes.surgical">
                    {{ 'MENU.PROCEDURES_SURGERIES' | translate }}
                  </a>
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul': activesection === 'formember'
                }" [routerLink]="routes.healthShare">{{ 'MENU.HEALTH_SHARE' | translate
                    }}</a>
                </div>
                <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="footer-menus">
              <div class="footer-menu-item">
                <div class="footer-menu-item-title main-tile d-flex justify-content-between"
                  (click)="onclick('about-us')">{{ 'MENU.ABOUT_US' | translate }}
                  <div class="menu-images">
                    <img *ngIf="activesection === 'about-us'" src="{{sharedService.imagesUrl}}icons/arrow-up.svg" />
                    <img *ngIf="activesection !== 'about-us'" src="{{sharedService.imagesUrl}}icons/arrow-down.svg" />
                  </div>
                </div>
                <div class="inner-links" (click)="closeimg($event)" [class.hide-li]="innerlink"
                  [class.show-li]="activesection === 'about-us'">
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul': activesection === 'about-us'
                }" [routerLink]="routes.aboutUs">{{ 'MENU.ABOUT_US' | translate }}</a>
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul': activesection === 'about-us'
                }" [routerLink]="routes.contactUs">{{ 'MENU.CONTACT_US' | translate }}</a>
                </div>
                <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div>
              </div>
              <div class="footer-menu-item">
                <div class="footer-menu-item-title d-flex justify-content-between" (click)="onclick('resources')">{{
                  'MENU.RESOURCES' | translate }}
                  <div class="menu-images">
                    <img *ngIf="activesection === 'resources'" src="{{sharedService.imagesUrl}}icons/arrow-up.svg" />
                    <img *ngIf="activesection !== 'resources'" src="{{sharedService.imagesUrl}}icons/arrow-down.svg" />
                  </div>
                </div>
                <div class="inner-links" (click)="closeimg($event)" [class.hide-li]="innerlink"
                  [class.show-li]="activesection === 'resources'">
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul' : activesection === 'resources'
                }" [routerLink]="routes.resources">{{ 'MENU.FAQ_AND_VIDEOS' | translate }}</a>
                  <a class="footer-menu-item-menu" [ngClass]="{
                  'show-ul' : activesection === 'resources'
                }" [href]="routes.blogs">{{ 'MENU.BLOGS' | translate }}</a>

                </div>
                <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="footer-menus">
              <div class="footer-menu-item singup-menu">
                <div class="footer-menu-item-title main-tile d-flex justify-content-between"
                  (click)="onclick('signupas')">{{ 'FOOTER.SIGNUP_AS' | translate }}
                  <div class="menu-images">
                    <img *ngIf="activesection === 'signupas'" src="{{sharedService.imagesUrl}}icons/arrow-up.svg" />
                    <img *ngIf="activesection !== 'signupas'" src="{{sharedService.imagesUrl}}icons/arrow-down.svg" />
                  </div>
                </div>
                <div class="inner-links" (click)="closeimg($event)" [class.hide-li]="innerlink"
                  [class.show-li]="activesection === 'signupas'">
                  <a [href]="employers_provider" target="_blank" [ngClass]="{
                  'show-ul' : activesection === 'signupas',
                  'show-singupbtn': activesection === 'signupas'
                }">
                    <div class="footer-menu-item-menu" [ngClass]="{
                  'show-ul' : activesection === 'signupas'
                }">
                      {{ 'FOOTER.EMPLOYERS' | translate }}
                    </div>
                  </a>

                  <a [href]="providers" target="_blank" class="singup-btn" [ngClass]="{
                  'show-ul' : activesection === 'signupas'
                }">
                    <div class="footer-menu-item-menu" [ngClass]="{
                  'show-ul' : activesection === 'signupas'
                }">{{ 'FOOTER.PROVIDER' | translate }}</div>
                  </a>
                </div>


                <!-- <div class="footer-menu-item-line">
                  <svg xmlns="http://www.w3.org/2000/svg" width="335" height="1" viewBox="0 0 335 1" fill="none">
                    <path d="M0 0.568359H335" stroke="white" stroke-width="0.5" />
                  </svg>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        }
        <!-- Footer Menus End -->
      </div>
    </div>
    <div class="row quotetion-row" *ngIf="sharedService.hideFooterRightSection">
      <div class="col-lg-3 col-md-4 col-sm-3 iconfooter-quotetion">
        <div class="footer-desc-section-icons-quotation">
          <div class="footer-desc-section-icon-quotation">
            <a [href]="Facebook" target="_blank" class="img-tage">
              <img src="{{sharedService.imagesUrl}}queation-facbook.png" class="img-fluid facbook-quation" />
            </a>

          </div>
          <div class="footer-desc-section-icon-quotation">
            <a [href]="Linkedin" target="_blank" class="img-tage">
              <img src="{{sharedService.imagesUrl}}linkdinquotation.png" class="img-fluid" />
            </a>
          </div>
          <div class="footer-desc-section-icon-quotation">
            <a [href]="Instragram" target="_blank" class="img-tage">
              <img src="{{sharedService.imagesUrl}}qutetioninstagram.png" class="img-fluid" />
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-9 col-md-8 col-sm-9 term-content">
        <div class="copyrightdiv-logo quotetation-logos">
          <!-- Image will moved to assets later -->
          <img [src]="sharedService.imagesUrl+'pci-complaint.svg'" width="46" height="56" alt="" />
          <img [src]="sharedService.imagesUrl+'aicpa-icon.svg'" width="47" height="56" alt="" />
          <img [src]="sharedService.imagesUrl+'hippa-compliance.svg'" width="77" height="56" alt="" />

          <!-- Image will moved to assets later -->
        </div>
        <div class="quotetion-copyright">
          <div class="copyrightdiv-text">
            Copyright © {{currentYear}} WoW Health Solutions. All Rights Reserved
          </div>
          <!-- <div class="termprivacy"> -->
          <a (click)="openTermUseModal()">Terms of use</a>
          <!-- <a (click)="openPrivacyPoliciesModal()">Privacy policy</a> -->
          <!-- </div> -->
        </div>
      </div>
      <div class="col-lg-12 qutetion-col">
        <div class="responcive-write">
          <a (click)="openTermUseModal()">Terms of use</a>
          <div class="copyrightdiv-text quotation-copy">
            Copyright © {{currentYear}} WoW Health Solutions. All Rights Reserved
          </div>
          <!-- <div class="termprivacy"> -->
          <!-- <a (click)="openPrivacyPoliciesModal()">Privacy policy</a> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    @if(!sharedService.hideFooterRightSection && !hasWellnessMembership){
    <div class="row">
      <div class="col-md-12 ">
        <div class="footer-disclaimer">
          <h4 class="mb-3 mt-0"> {{ 'FOOTER.DISCLAIMER_TITLE' | translate: { tenant: 'WOW' } }}</h4>
          <p class="m-0">
            {{ 'FOOTER.DISCLAIMER_DESCRIPTION' | translate: { tenant: 'WOW' } }}
          </p>
        </div>
      </div>
    </div>
    }
    <div class="row copyright-section" *ngIf="!sharedService.hideFooterRightSection">
      <div class="col-md-12  d-flex justify-content-between align-items-center flex-wrap">
        <div class="copyrightdiv-logo order-1 order-md-1 w-xs-100 ">
          <!-- Image will moved to assets later -->
          <img [src]="sharedService.imagesUrl+'pci-complaint.svg'" width="64" height="56" alt="" />
          <img [src]="sharedService.imagesUrl+'aicpa-icon.svg'" width="62" height="56" alt="" />
          <img [src]="sharedService.imagesUrl+'hippa-compliance.svg'" width="104" height="56" alt="" />

          <!-- Image will moved to assets later -->
        </div>
        <!-- <div class="copyrightdiv-left"> -->
        <div class="copyrightdiv-text order-3 order-md-2 w-xs-100">
          Copyright © {{currentYear}} WoW Health Solutions. All Rights Reserved
        </div>
        <div class="termprivacy order-2 order-md-2 w-xs-100">
          <a (click)="openTermUseModal()">Terms of use</a>
          <!-- <a (click)="openPrivacyPoliciesModal()">Privacy policy</a> -->
        </div>
        <!-- </div> -->
      </div>
    </div>

  </div>
</footer>
}

<app-terms-of-use-modal></app-terms-of-use-modal>
<!-- <app-privacy-policy-modal></app-privacy-policy-modal> -->